module.exports = __webpack_public_path__ + "assets/img/mecha-00aefa5e.png";